import SvgReturncwIcon from '@ordr-as/icons/lib/ReturncwIcon';
import { Button } from '@ordr-as/umami-react/button';

interface ExpandHeaderButtonProps {
  onExpandHeaderClick: () => void;
  isPhone?: boolean;
  isExpanded?: boolean;
}

const ExpandHeaderButton = (props: ExpandHeaderButtonProps) => {
  const { onExpandHeaderClick, isPhone, isExpanded = false } = props;

  const onButtonClick = () => {
    onExpandHeaderClick();
  };
  const expandHeaderStyling = isPhone
    ? `absolute right-2 top-3 z-10 flex items-center justify-center rounded-full border shadow-md bg-brand-white ${
        isExpanded ? 'bg-purple-lightest border-brand-primary ' : 'border-grey-medium'
      }`
    : `absolute top-2 right-0 z-10 flex items-center justify-center rounded-full border shadow-md bg-brand-white ${
        isExpanded ? 'bg-purple-lightest border-brand-primary ' : 'border-grey-medium'
      }`;

  return (
    <Button height={36} onClick={onButtonClick} className={expandHeaderStyling} aria-label="Show more">
      <SvgReturncwIcon className={`mx-2 ${isExpanded && 'text-brand-primary'}`} />
    </Button>
  );
};

export default ExpandHeaderButton;
